var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "w-100 h-100 d-flex flex-column align-items-center justify-content-center gap-150",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.openFileUploadDialog.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column align-items-center font-size-125 py-3",
        },
        [
          _c("i", {
            staticClass: "fa fa-cloud-upload-alt fa-5x vue-uploadbox-icon",
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "px-1 text-center vue-uploadbox-drop-text",
              class: _vm.darkText,
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("trans")("Drop Files here")) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btn-group" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-light font-size-125 font-weight-bold text-nowrap vue-uploadbox-file-button position-static",
            class: { "rounded-bottom-0": _vm.showDropdown },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.openFileUploadDialog.apply(null, arguments)
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("trans")("Choose File")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn btn-light dropdown-toggle dropdown-toggle-split border-left",
            class: { "rounded-bottom-0": _vm.showDropdown },
            attrs: {
              type: "button",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false",
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.toggleDropdown.apply(null, arguments)
              },
            },
          },
          [_c("i", { staticClass: "fa fa-chevron-down" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "dropdown-menu m-0 w-100 br-4 rounded-top-0 user-select-none",
            class: { show: _vm.showDropdown },
            attrs: { id: "dropdownMenu" },
          },
          [
            _c("div", { staticClass: "dropdown-item px-0" }, [
              _c(
                "span",
                {
                  staticClass:
                    "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                  attrs: {
                    id: "DeviceUploadButton",
                    title: _vm._f("trans")("Upload From Device"),
                    tag: "span",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.openFileUploadDialog.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._m(0),
                  _vm._v(
                    _vm._s(_vm._f("trans")("From Device")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-item px-0" }, [
              _c(
                "span",
                {
                  staticClass:
                    "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                  attrs: {
                    id: "dropboxButton",
                    title: _vm._f("trans")(
                      "Choose one or more files from Dropbox"
                    ),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.openDropboxDialog.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "px-75" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 43 40",
                          version: "1.1",
                          width: "15px",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
                            fill: "#007EE5",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(
                    _vm._s(_vm._f("trans")("From Dropbox")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-item px-0",
                class: { "opacity-65": _vm.disableGdriveButton },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.openGdriveDialog.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                    attrs: {
                      id: "gdriveButton",
                      title: _vm._f("trans")(
                        "Choose one or more files from Google Drive"
                      ),
                    },
                  },
                  [
                    _c("span", { staticClass: "px-75" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "15px",
                            viewBox: "0 0 87.3 78",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z",
                              fill: "#0066da",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z",
                              fill: "#00ac47",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z",
                              fill: "#ea4335",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z",
                              fill: "#00832d",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
                              fill: "#2684fc",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z",
                              fill: "#ffba00",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(
                      _vm._s(_vm._f("trans")("From Google Drive")) +
                        "\n                "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dropdown-item px-0" },
              [
                _c(
                  "RouterLink",
                  {
                    staticClass:
                      "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                    attrs: {
                      id: "externalUrlButton",
                      to: { name: "remote-url" },
                      title: _vm._f("trans")(
                        "Enter the link of a file you want to use"
                      ),
                      tag: "span",
                    },
                  },
                  [
                    _c("span", { staticClass: "px-75" }, [
                      _c("i", {
                        staticClass: "fa fa-link",
                        staticStyle: { width: "15px" },
                      }),
                    ]),
                    _vm._v(
                      _vm._s(_vm._f("trans")("From URL")) + "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "px-75" }, [
      _c("i", {
        staticClass: "fa fa-folder-open",
        staticStyle: { width: "15px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }